module.exports = __webpack_public_path__ + "static/media/react2.34ecaea9.png";